import { Divider, Space } from "antd";
import Paragraph from "antd/lib/typography/Paragraph";
import Title from "antd/lib/typography/Title";

const AboutBindeleddet = () => {
  return (
    <>
      <Space direction="horizontal" style={{ width: "100%", justifyContent: "center" }}>
        <Title>Om oss</Title>
      </Space>
      <Divider />
      <Paragraph style={{ fontSize: "1.1em" }}>
        Bindeleddet NTNU er et kontaktorgan mellom næringslivet og sivilingeniørstudentene ved Industriell økonomi og
        teknologiledelse (Indøk) på NTNU. Bindeleddet NTNU gir bedrifter mulighet til å profilere seg overfor
        Indøk-studenter og ellers på campus Gløshaugen ved å tilby bedriftspresentasjoner, rekrutteringsdager og andre
        tjenester. Gjennom økt interaksjon med bedriftenes medarbeidere, ønsker Bindeleddet NTNU at studentene får
        utvidet forståelse for næringslivet og kunnskap om sine karrieremuligheter.
      </Paragraph>
      <Title level={3}>Organisasjon</Title>
      <Paragraph style={{ fontSize: "1.1em" }}>
        Bindeleddet NTNU er delt opp i fem grupper. Bedriftsgruppen har hovedansvaret for bedriftspresentasjoner,
        booking av bedrifter og jobbkatalogen. Markedsføringsgruppen jobber med å markedsføre Indøk og Bindeleddet NTNU
        mot næringslivet, både i Norge og i utlandet. IT-gruppen er ansvarlig for nettsidene, Bindeleddet NTNUs
        databaser og Intranett, samt diverse prosjekter. Økonomi og finans-gruppen bidrar i økonomiske avgjørelser og
        fører Bindeleddet NTNUs regnskap. Analysegruppen jobber med å analysere og presentere data fra undersøkelser og
        gir organisasjonen beslutningstøtte. I tillegg har vi en rekke prosjekter som organiseres på tvers av gruppene.
      </Paragraph>
      <Title level={3}>Hva vi gjør</Title>
      <Paragraph style={{ fontSize: "1.1em" }}>
        For studenter arrangerer Bindeleddet NTNU bedriftspresentasjoner, KarriereDagene, ekskursjoner og
        kompetansehevingsarrangementer. I tillegg legger vi ut stillingsannonser på sidene våre, formidler
        diplomoppgaver, gjennomfører arbeidssituasjonsundersøkelser for ferdigutdannede indøkere og markedsfører Indøk
        mot næringslivet.
      </Paragraph>
    </>
  );
};

export default AboutBindeleddet;
